import React, { Component } from 'react';
import { FormGroup, FormControl, Image}  from 'react-bootstrap';
import {Card, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton'
import mozak from '../../assets/mozak.png';
import screens from '../../assets/screens.png';
import play from '../../assets/play_store.png';
import app from '../../assets/app_store.png';
import { connect } from 'react-redux';
import { loginUser, emailChanged, passwordChanged, checkChanged, signUpUser } from './auth_actions';

class Login extends Component {
  constructor(){
    super();
    this.state={
      login: true
    }
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleEmailChange(event) {
    this.props.emailChanged(event.target.value)
  }

  handlePasswordChange(event) {
    this.props.passwordChanged(event.target.value)
  }

  handleCheck() {
    this.props.checkChanged(!this.props.checked);
  }

  handleLogin() {
    const { email, password, checked } = this.props;
    this.props.loginUser({ email, password, checked });
  }

  handleSignUp() {
    const { email, password, checked } = this.props;
    this.props.signUpUser({email, password, checked })
  }

  render() {
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 60}}>
            <div>
              <img src={screens} style={{ width: 400}} alt="mozak"/>
            </div>
            
            <div style={{ marginLeft: 20, marginTop: 60 }}>
              {
                this.state.login ? this.renderLoginForm() : this.renderSignUpForm()
              }
              <div style={{ width: 380, display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                Get the app.
              </div>
          
              <div style={{ width: 380, display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                <a href="https://play.google.com/store/apps/details?id=com.mozak_mobile"><img src={play} style={{ width: 150 }} alt="mozak"/></a>
                <a href="https://itunes.apple.com/us/app/mymozak/id1312656775?ls=1&mt=8"><img src={app} style={{ width: 150 }} alt="mozak"/></a>
              </div>
            </div>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: 40}}>
            <a href="https://www.mymozak.com/press.html" style={{ color: 'black', margin: 10 }}>PRESS</a>
            <a href="https://www.mymozak.com/terms.html" style={{ color: 'black', margin: 10 }}>TERMS</a>
            <a href="https://www.mymozak.com/policy.html" style={{ color: 'black', margin: 10 }}>PRIVACY</a>
            <a href="https://mozak.recruitee.com/" style={{ color: 'black', margin: 10 }}> CAREERS </a>
            <a style={{ color: 'black', margin: 10, fontSize: 10 }} >COPYRIGHT © 2018. ALL RIGHTS RESERVED. MOZAK</a>
        </div>

      </div>
    )
  }

  renderButton() {
    if (this.props.loading) {
      return <p> Loading...</p>
    } else if (this.state.login) {
      return <RaisedButton onClick={this.handleLogin} backgroundColor={'#2196F3'} label="Login" fullWidth={true} />
    } else {
      return <RaisedButton onClick={this.handleSignUp} backgroundColor={'#2196F3'} label="Sign Up" fullWidth={true} />
    }
  }

  renderLoginForm() {
      return (
        <div>
          <Card
            style={{
              backgroundColor: 'white',
              width: 380,
              height: '50%',
              paddingTop: 50,
              paddingLeft: 20,
              paddingRight: 20
            }}>

          <CardText>
            <div
              style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src={mozak} style={{ width: 250}} alt="mozak"/>
            </div>
            <br />
            <br />
              <FormGroup bsSize="lg">
                <FormControl placeholder="Username" value={this.props.email} onChange={this.handleEmailChange}/>
              </FormGroup>
              <FormGroup bsSize="lg">
                <FormControl type="password" placeholder="Password" value={this.props.password} onChange={this.handlePasswordChange} />
              </FormGroup>
              <p style={{ color: 'red', textAlign: 'center'}}>{this.props.error}</p>
              <Checkbox
                label="Realtor? Check this box."
                labelStyle={{ color: '#000000'}}
                style={{ margin: 10 }}
                checked={this.props.checked}
                onCheck={this.handleCheck}
              />
                {this.renderButton()}
          </CardText>
        </Card>
        <br />
        <Card style={{ width: 380, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center', backgroundColor: 'white' }}>
          <CardText>
            <p style={{ color: 'black' }}>Don't have an account? <a onClick={() => this.setState({ login: !this.state.login })} style={{ cursor: 'pointer'}} >Sign up</a></p>
          </CardText>
        </Card>
      </div>
    )
  }

  renderSignUpForm() {
    return (
      <div>
        <Card
          style={{
            backgroundColor: 'white',
            width: 380,
            height: '50%',
            paddingTop: 50,
            paddingLeft: 20,
            paddingRight: 20
          }}>

        <CardText>
          <div
            style={{display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={mozak} style={{ width: 250}} alt="mozak"/>
          </div>
          <br />
          <br />
            <FormGroup bsSize="lg">
              <FormControl placeholder="Username" value={this.props.email} onChange={this.handleEmailChange}/>
            </FormGroup>
            <FormGroup bsSize="lg">
              <FormControl type="password" placeholder="Password" value={this.props.password} onChange={this.handlePasswordChange} />
            </FormGroup>
            <p style={{ color: 'red', textAlign: 'center'}}>{this.props.error}</p>
            <Checkbox
                label="Realtor? Check this box."
                labelStyle={{ color: '#000000'}}
                style={{ margin: 10 }}
                checked={this.props.checked}
                onCheck={this.handleCheck}
              />
              {this.renderButton()}
            
            <div style={{ textAlign: 'center', marginTop: 5 }}>
              By signing up, you agree to our <a href="https://www.mymozak.com/terms.html">Terms</a> & <a href="https://www.mymozak.com/policy.html">Privacy Policy</a>.
            </div>
        </CardText>
      </Card>
      <br />
      <Card style={{ width: 380, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center', backgroundColor: 'white' }}>
        <CardText>
          <p style={{ color: 'black' }}>Have an account? <a onClick={() => this.setState({ login: !this.state.login })} style={{ cursor: 'pointer'}} >Login</a></p>
        </CardText>
      </Card>
    </div>
  )
 } 

}

const mapStateToProps = ({auth}) => {
  const { email, password, error, checked, loading }  = auth;
  return { email, password, error, checked, loading };
};

export default connect(mapStateToProps,{ emailChanged, passwordChanged, checkChanged, loginUser, signUpUser })(Login);



// WEBPACK FOOTER //
// ./src/components/auth/auth.js